import { Dispatch, RefObject, SetStateAction } from 'react';
import MyModal from '../../../../components/Modal';
import { QrCodesGrid } from '../styles';
import { MappedVehicleType } from '../types';
import QRCode from 'react-qr-code';

interface AllQrCodesModalInterface {
  allQrCodesModalShow: boolean;
  companyName: string;
  setAllQrCodesModalShow: Dispatch<SetStateAction<boolean>>;
  downloadQrCodes: () => void;
  exportRef: RefObject<HTMLDivElement>;
  areQrCodesDownloading: boolean;
  vehicles: MappedVehicleType[];
}

export default function AllQrCodesModal({
  allQrCodesModalShow,
  companyName,
  setAllQrCodesModalShow,
  downloadQrCodes,
  exportRef,
  areQrCodesDownloading,
  vehicles,
}: AllQrCodesModalInterface) {
  return (
    <MyModal
      show={allQrCodesModalShow}
      title={`QR Codes veículos ${companyName}`}
      isActionButtonDisabled={areQrCodesDownloading}
      modalBody={(
        <QrCodesGrid ref={exportRef}>
          {vehicles?.map((vehicle) => (
            <div key={vehicle.vehicleId}>
              <h1>{vehicle.vehicleCode}</h1>
              <h1>{companyName}</h1>
              <h1>
                      Qr Code:
                {' '}
                {vehicle.qrCode}
              </h1>
              <QRCode
                value={`${vehicle.qrCode}`}
                size={50}
                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                viewBox="0 0 50 50"
              />
            </div>
          ))}
        </QrCodesGrid>
      )}
      closeButtonLabel="Fechar"
      onClose={() => setAllQrCodesModalShow(false)}
      actionButtonLabel="Download"
      onAction={() => downloadQrCodes()}
      type="action"
      size="xl"
    />
  );
}
